import React from "react";
import NeshanMap from "react-neshan-map-leaflet";
import { setLAT_LNG } from "../redux/Login/LoginActionCreators";
import { getRegisterAddress } from "../redux/Login/LoginActions";
import Store from "../redux/Store";
require("dotenv").config();

const Map = ({ lat, lng }) => {
  return (
    <NeshanMap
      options={{
        key: process.env.REACT_APP_MAP_ACCESS_TOKEN,
        center: [
          lat !== undefined ? lat : 35.699739,
          lng !== undefined ? lng : 51.338097,
        ],
        zoom: 13,
      }}
      onInit={(L, myMap) => {
        let marker = L.marker([
          lat !== undefined ? lat : 35.699739,
          lng !== undefined ? lng : 51.338097,
        ])
          .addTo(myMap)
          .bindPopup("آدرس دفتر");
        if (lat === undefined) {
          myMap.on("click", function (e) {
            marker.setLatLng(e.latlng);
            getRegisterAddress([
              e.latlng,
              Store.getState().loginReducer.Register_Mobile_Email,
            ]);
            Store.dispatch(setLAT_LNG(e.latlng));
          });
        }
      }}
    />
  );
};

export default Map;
